import { createApi } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'

interface InitiralizeResponse {
  signedQuery: string
}

export const initializeApi = createApi({
  reducerPath: 'initializeApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Initialize'],
  endpoints: (builder) => ({
    initialize: builder.query<null, null>({
      query: () => ({
        url: `${CONSTANTS.API.INITIALIZE}`
      }),
      providesTags: ['Initialize'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useInitializeQuery } = initializeApi

// const InitializeService = {
//   initialize: async () => {
//     const result = await axios.get(CONSTANTS.API.INITIALIZE)
//     const data: InitiralizeResponse = result.data

//     if (data) {
//       console.log(data)
//       // TODO: replace storage service with the store
//       // StorageService.set(CONSTANTS.STORAGE_KEYS.SIGNED_URL, data.signedQuery);
//     }
//   },
// }

// export default InitializeService
